<template>
  <div class="app-wrapper" :class="store.getters.sideBarOpened ? 'menu-open' : 'hideSidebar'">
    <Sidebar class="sidebar-container" :style="{ background: variables.menuBg }"></Sidebar>
    <div id="maincontainer" class="main-container">
      <div class="fixed-header">
        <Navbar></Navbar>
      </div>
      <BusinessNotification admin /><NotificationExperiencePreview admin /><app-main></app-main>
      <WechatBindingReminder channel="admin" />
      <BranchAdminNotice channel="admin" />
      <OrderRowDetailHost />
    </div>
  </div>
</template>
<script lang="ts">
import BusinessNotification from "@/components/BusinessNotification.vue"
import NotificationExperiencePreview from "@/components/NotificationExperiencePreview.vue"
import Navbar from './components/Navbar.vue'
import WechatBindingReminder from '@/components/WechatBindingReminder.vue'
import BranchAdminNotice from '@/components/BranchAdminNotice.vue'
import OrderRowDetailHost from '@/components/OrderRowDetailHost.vue'
import AppMain from './components/AppMain.vue'
import Sidebar from './components/sidebar/index.vue'
// import { watch } from 'vue'
import variables from '@/assets/styles/variables.module.scss'
import store from '@/store'
import { defineComponent, onMounted, ref, watch, watchEffect } from 'vue'
// watch(store.getters.sideBarOpened,()=>{
//   variables.$sideBarWidth='80px'
//     })
export default defineComponent({
  components: {
    BusinessNotification, NotificationExperiencePreview,
    WechatBindingReminder, Navbar, AppMain, Sidebar, BranchAdminNotice, OrderRowDetailHost
  },
  setup() {
    onMounted(()=>{
      window.document.title=store.getters.userInfo.orgName+'管理端'
      store.dispatch('user/getSettings')
    })
    return {
      variables, store
    }
  }
})
</script>
<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';
@import '~@/assets/styles/variables.module.scss';


.app-wrapper {
  @include clearfix;
  position: relative;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  display: flex;
  overflow: hidden;
}

// 2026-09-22：导航说明自适应高度，正文占剩余视口并独立滚动。
.main-container { display:flex; flex-direction:column; height:100vh; min-height:0; }

.fixed-header {
  z-index: 9;
  width: calc(100vw - #{ $sideBarWidth });
  min-height: $fixedHeaderHeight;
  height: auto;
  flex: 0 0 auto;
  // position: fixed;
  // top: 0;
  transition: width #{$sideBarDuration};
  box-shadow: 0px 7px 14px 0px rgba(0, 0, 0, 0.05);
  background-color: #fff;
}
</style>
